<!--
 * :Date: 2024-07-25 15:44:44
 * :Description: 
 * :Author: zq.wei
 * :LastEditors: zq.wei
 * :LastEditTime: 2024-10-31 16:18:06
-->
<template>
  <el-input
    v-model="cv"
    :maxlength="maxLength"
    :placeholder="placeholder"
    @input="cvInput"
    @blur="cvBlur"
    :disabled="disabled"
  >
    <template v-if="showYuan" slot="prefix">
      ￥
    </template>
    <template #suffix v-if="showYuan">
      元
    </template>
  </el-input>
</template>

<script>
export default {
  name: "inputAmount",
  props: {
    value: {
      type: [String, Number]
    },
    placeholder: {
      type: String,
      default: "请输入"
    },
    disabled: {},
    // 输入整数
    isInt: Boolean,
    maxLength: Number,
    maxNum: Number,
    minNum: Number,
    scale: [Number, String],
    showYuan: {
      // 显示元
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cv: ""
    };
  },
  watch: {
    value: {
      handler(val) {
        if (typeof val == "number") {
          this.cv = val + "";
        } else {
          this.cv = val;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    cvBlur() {
      const { cv } = this;

      if (cv) {
        if (cv.startsWith("0") && cv[1] !== "." && cv.length > 1) {
          this.cv = 0;
          this.$emit("input", this.cv);
        } else if (cv.endsWith(".")) {
          this.cv = cv.slice(0, cv.length - 1);
          this.$emit("input", this.cv);
        }
      }
      this.$emit("blur");
    },
    cvInput(val) {
      if (this.isInt) {
        if (val !== "") {
          if (val < 0 || (this.maxNum && val > this.maxNum) || (this.minNum !== undefined && val < this.minNum)) {
            this.$set(this, "cv", "");
          } else {
            const gg = val.match(/\d+/);
            if (!gg) {
              this.cv = "";
            } else {
              this.cv = gg[0];
            }
          }
        }
      } else {
        if (val !== "") {
          if ((this.maxNum && val > this.maxNum) || (this.minNum !== undefined && val < this.minNum)) {
            this.cv = "";
          } else {
            let gg;
            if (this.scale) {
              gg = val.match(new RegExp("\\d+\\.?\\d{0," + this.scale + "}"));
            } else {
              gg = val.match(/\d+\.?\d{0,2}/);
            }
            if (!gg) {
              this.cv = "";
            } else {
              this.cv = gg[0];
            }
          }
        }
      }
      this.$emit("input", this.cv);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/inputAmount.vue